// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"1d8fcbbc","530":"2caafa7d"}[chunkId] + ".chunk.css";
};